/* eslint-disable no-undef, no-unused-vars, no-redeclare */
import $ from "jquery";

$(document).ready(function() {
  // Fallback: Use MutationObserver to set accept on file inputs created by plupload
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.tagName === "INPUT" && node.type === "file") {
          node.accept =
            ".jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,.txt,.xls,.xlsx,.ppt,.pptx";
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
